module.exports = __webpack_public_path__ + "static/bg-news-1b03763f287fede34cc614db32c2fe4e.jpg";